import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { InfoTooltipIcon } from '../../Feedback/InfoTooltipIcon';
import { Slider, SwitchWrapper, Wrapper, Text } from './styled';
export { SwitchField } from './SwitchField';
export const Switch = React.memo(React.forwardRef(function Switch({ checked, onChange, text, name, disabled, tooltip, inline, pseudoLabel, dataTestId, ...props }, ref) {
    const handleChange = useCallbackRef((e) => {
        onChange(e.target.checked);
    });
    return (_jsxs(Wrapper, { disabled: disabled, "$inline": inline, "$pseudoLabel": pseudoLabel, "data-testid": dataTestId, children: [_jsxs(SwitchWrapper, { "data-test-checked": checked || false, children: [_jsx("input", { checked: checked, onChange: handleChange, type: 'checkbox', name: name, id: name, disabled: disabled, ref: ref, ...props }), _jsx(Slider, {})] }), text && (_jsxs(Text, { disabled: disabled, children: [text, tooltip ? _jsx(InfoTooltipIcon, { tooltip: tooltip }) : ''] }))] }));
}));
